export default __webpack_public_path__ + "static/curve-33bda773d7808656d797b8f9a03e9c03.png";